/* --------------------------------------------------------------------------------------
   newUser.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const newUserComponent = {
  template: require('./newUser.html'),
  controller: 'newUserCtrl',
  controllerAs: 'vm',
  bindings: {
    back: '&',
    setPin: '&'
  }
}

export class newUserCtrl {
  /*@ngInject*/
  constructor(commonService, dataService, userService, appService, $translate) {
    this.commonService = commonService
    this.dataService = dataService
    this.userService = userService
    this.appService = appService
    this.$translate = $translate
  }
  $onInit() {
    this.commonService.setDefaultBackground()
    this.txtUser = angular.element('#txtUser')
    this.txtPassword = angular.element('#txtPassword')
    this.setKeyboards()
  }
  change() {
    if (this.txtUser.getkeyboard().$preview)
      this.user = this.txtUser.getkeyboard().$preview.val()
    if (this.txtPassword.getkeyboard().$preview)
      this.password = this.txtPassword.getkeyboard().$preview.val()

    angular.element('#btnSubmit').xrxbutton({ disabled: !(this.user && this.password) })
  }
  passwordAccepted() {
    if (this.user && this.password)
      this.submit()
  }
  submit() {
    this.working = true

    this.txtUser.getkeyboard().close();
    this.txtPassword.getkeyboard().close();

    this.user64 = btoa(this.user)
    this.password64 = btoa(this.password)
    if (this.userExists(this.user64)) {
      this.error = "LOGIN_ALREADY_EXISTS"
      this.working = false
    }
    else {
      this.goNextStep()
    }
  }
  goNextStep() {
    this.dataService.getEncrypted64(this.password64)
      .then(result => this.dataService.getToken(this.user64, result))
      .then(result => this.appService.setNewUserToken(this.user64, result))
      .then(() => {
        this.txtUser.getkeyboard().destroy();
        this.txtPassword.getkeyboard().destroy();
        this.setPin()
      })
      .catch(error => { //todo: handle 404
        this.txtPassword.val("")
        if (error.indexOf("Invalid") > -1) {
          this.error = "LOGIN_INVALID"
        } else {
          this.error = error
        }
      })
      .finally(() => { this.working = false })
  }
  setKeyboards() {
    this.$translate(['NEW_USER_USER', 'NEW_USER_PASSWORD'])
      .then(result => {
        $('#txtUser').xrxkeyboard({
          initialPlaceholder: result.NEW_USER_USER,
          theme: 'navy',
          backgroundSlide: true,
          change: () => this.change(),
          accepted: () => { $('#txtPassword').getkeyboard().reveal() },
          canceled: function (event, keyboard, el) { $('#txtUser').val(keyboard.last.val) }
        });

        $('#txtPassword').xrxkeyboard({
          initialPlaceholder: result.NEW_USER_PASSWORD,
          theme: 'navy',
          backgroundSlide: true,
          change: () => this.change(),
          canceled: function (event, keyboard, el) { $('#txtPassword').val(keyboard.last.val) },
          accepted: (event, keyboard, el) => { if (keyboard.last.key == 'Enter') {this.passwordAccepted()} }
        });
      })
  }
  userExists(user64) {
    return this.userService.getUsers().map(obj => obj.user64).includes(user64)
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/newUser.component.js